import React from "react";
import { Grid } from "@material-ui/core";

import useStyles from "./styles";

const List = ({ children }) => {
  const { lRoot } = useStyles();
  return (
    <Grid item container className={lRoot}>
      {children}
    </Grid>
  );
};

export default List;
